import { Component, OnInit } from '@angular/core';
import { ArchiveService } from '../../service/archive/archive.service';
import { Archive } from '../../class/archive';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { config } from '../../../../../environments/config';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';

@Component({
  selector: 'app-archives',
  templateUrl: './archives.component.html',
  styleUrls: ['./archives.component.scss']
})
export class ArchivesComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public archives: Archive[];
    public selectArchive: Archive;
    public archiveID: Number = 0;
    public modNew = false;
    public modView = false;
    public openArchive = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;

    public query: string;
    public first = 0;

    public filters: any[];

    public form3: FormGroup;
    public company_id_filter: AbstractControl;
    public candidate_id_filter: AbstractControl;
    public recruited_by_id_filter: AbstractControl;
    public interviewed_by_id_filter: AbstractControl;
    public documental_analysis_by_id_filter: AbstractControl;
    public hire_by_id_filter: AbstractControl;

    public modExportDialog: boolean;

    public form4: FormGroup;
    public f4_date_start: AbstractControl;
    public f4_date_end: AbstractControl;

    public apiUrl = config.API_ROOT;

    public es: any;

    constructor(
        public archiveService: ArchiveService,
        public confirmationService: ConfirmationService,
        public hasPermissionService: HasPermissionService,
        public translate: TranslateService,
        public fb: FormBuilder) { 
            this.form3 = fb.group({
                'candidate_id_filter': [''],
            });
            this.candidate_id_filter = this.form3.controls['candidate_id_filter'];    

            this.modExportDialog = false;

            this.form4 = fb.group({
                'f4_date_start': ['', [Validators.required]],
                'f4_date_end': ['', [Validators.required]],
            });
            this.f4_date_start = this.form4.controls['f4_date_start'];
            this.f4_date_end = this.form4.controls['f4_date_end'];

            this.es = calendarES();        
        }

    ngOnInit() {
        this.page = 1;
        this.per_page = 10;
        this.sort = '-id';
    
        //this.getArchives();
    }

    public loadArchivesLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        
        if (event.sortField) {
            if (event.sortOrder === -1) {
                this.sort = '-' + event.sortField;
            } else {
                this.sort = event.sortField;
            }
        } else {
            this.sort = '-id';
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }
                
        this.getArchives();
    }

    public getArchives() {
        this.archiveService.getArchive(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                this.archives = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newArchive() {
        this.modNew = !this.modNew;
        this.selectArchive = null;
    }

    public savedArchive(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectArchive = null;
        this.modNew = false;
        this.getArchives();
    }

    public cancelArchive (res) {
        this.selectArchive = null;
        this.modNew = false;
        this.modView = false;
        this.getArchives();
    }

    public edit(archive: Archive) {
        this.modNew = true;
        this.selectArchive = archive;
        this.getArchives();
    }

    public view(archive: Archive) {
        this.openArchive = true;
        this.selectArchive = archive;
        this.archiveID = archive.id;
        this.modView = true;
    }

    public deleteDialog(archive: Archive) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(archive);
            }
        });
    }

    public delete(archive: Archive) {
        this.archiveService.deleteArchive(archive.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getArchives();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeArchive(archive: Archive) {
        this.putArchive(archive);
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public putArchive(values: Archive) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.archiveService.updateArchive(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    public filter (values?) {
        this.first = 0;
        this.filters = [];
        if (values) {
            if (values.candidate_id_filter) {
                this.filters.push({'key': 'candidate_id-lk', 'value': values.candidate_id_filter.id});
            }
        }

        this.getArchives();
    }

    public showExportDialog() {
        this.modExportDialog = true;
    } 

    public cancelExport() {
        this.modExportDialog = false;
    }

    public exportReportExcel(values) {
        let d = new Date(values.f4_date_start);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);

        const f4_date_start = formatDate(d);

        d = new Date(values.f4_date_end);
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(59);
        const f4_date_end = formatDate(d);

        let url = this.apiUrl + '/archives/excel?' +
        'token=' + localStorage.getItem('token') +
        '&_page=1&_limit=100000&_sort=-id'+
        '&created_at-min='+f4_date_start+'&created_at-max='+f4_date_end;

        window.open(url, '_blank');
    }

    
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/archives/archives.component.ts